import * as React from "react";
const PageTemplate = (props) => {
  return (
    <div>
        <div
          className="row"
          style={{
            position: "absolute",
            top: "1px",
            left: "12px",
            width: "100%",
            backgroundColor:"rgb(38 42 43)",
            padding:"20px"
          }}
        >
          <div className="logoimage" style={{ margin: "0 auto", opacity:"2" }} >
              <img src={require('Assets/img/tsga-logo.png')} className="img-fluid" alt="site-logo" width="200" height="20" />
          </div>
          
        </div>

        <span className="row" style={{position: "absolute", zIndex: "-5", opacity:"0.09", alignItems: "center", display: "flex", justifyContent: "center",left: "0px", top: "0px", bottom: "0px", margin:"0 auto", width: "100%"}}>
          <img src={require('Assets/img/tsga_watermark.png')} className="img-fluid" alt="site-logo" style={{
            content: "",
            backgroundRepeat: "no-repeat",
            margin: "0 auto",
            width:"65%"            
          }}/>
        </span>  

        <div className="row" style={{ position: "absolute", border:"1px solid #494a48", bottom:"15px", width: "90%", margin:"0 auto", marginTop:"80px"}}>
          <div className="col-md-4" style={{ padding:"10px", border:"1px solid #494a48", color: "#000", backgroundColor: "#b0e84f"}}>Team Sport Science</div>
          <div className="col-md-8" style={{ padding:"10px", color:"blue"}}>Tarun Sardesai Golf Pvt. Ltd.</div>
        </div>
    </div>  
    
  );
};
export default PageTemplate;